import React from "react";
import { css } from "styled-components";
import NoProductImage from "../../assets/Images/NoProductImage.jpeg";
import ProductLabels from "./ProductLabels";
import { Container, H3, Img, Label } from "../../Styles/Global.Styled";
import { useNavigate } from "react-router-dom";

const containerStyle = css`
  flex-direction: column;
  background-color: white;
  border-radius: 12px;
  gap: 0.75vh;
  width: 17vw;
  padding-bottom: 1vh;
  box-shadow: 0 0 1px grey;
  cursor: pointer;
`;
const cntWidth = css`
  width: 80vw;
`;
const imgSize3 = css`
  height: 30vh;
`;
const h3Style = css`
  font-size: 1.6vh;
  padding: 0 0.5vh;
  color: ${({ theme }) => theme.secColor};
  text-align: center;
`;
const priceLabelStyle = css`
  align-self: flex-end;
  padding-right: 2vh;
`;

const ProductAd = ({ item }) => {
  const navigate = useNavigate();

  return (
    <Container
      $baseStyle={containerStyle}
      $mStyle={cntWidth}
      onClick={() =>
        navigate(`/product/${item.product_code}`, {
          state: { product: item },
        })
      }
    >
      <Img
        $baseStyle={imgSize3}
        src={item.imageURL ? item.imageURL : NoProductImage}
      />
      <H3 $baseStyle={h3Style}>{item.product_name}</H3>
      <ProductLabels product={item} />
      <Label $baseStyle={priceLabelStyle}>
        £{`${item.price.toFixed(2)}`}
      </Label>
    </Container>
  );
};

export default ProductAd;
